import React from 'react';
import { motion } from 'framer-motion';
export function Timeline() {
  const steps = [{
    num: '01',
    title: 'Llenas el Formulario',
    text: 'Con tus propias palabras, sin presión, sin guión. Solo tu verdad, exactamente como es.'
  }, {
    num: '02',
    title: 'Lorena Lee Tu Historia',
    text: 'Personalmente. Con cariño. Cada palabra que escribiste es leída y valorada con el mayor respeto.'
  }, {
    num: '03',
    title: 'Tu Historia Cobra Vida',
    text: 'Con tu autorización, tu experiencia llega a otras mujeres que la necesitan desesperadamente hoy.'
  }, {
    num: '04',
    title: 'Inspiras Sin Límites',
    text: 'Tu transformación se convierte en el permiso que otra mujer estaba esperando para empezar su propio camino.'
  }];
  return <section className="py-24 px-6 bg-deep-blue overflow-hidden" data-id="element-279">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-280">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-playfair font-bold text-white text-3xl md:text-[42px] leading-[1.2] text-center mb-20" data-id="element-281">
          Cuando Compartes Tu Historia
          <br data-id="element-282" />
          Pasan Cosas Hermosas
        </motion.h2>

        <div className="relative w-full" data-id="element-283">
          {/* Center Line Desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-[2px] bg-champagne-gold -translate-x-1/2" data-id="element-284"></div>

          <div className="flex flex-col gap-12 md:gap-24" data-id="element-285">
            {steps.map((step, index) => {
            const isEven = index % 2 === 0;
            return <div key={index} className="relative flex flex-col md:flex-row items-center w-full" data-id="element-286">
                  {/* Mobile Line */}
                  <div className="md:hidden absolute left-6 top-12 bottom-[-48px] w-[2px] bg-champagne-gold z-0" data-id="element-287"></div>

                  {/* Desktop Layout */}
                  <div className={`hidden md:flex w-full ${isEven ? 'justify-start' : 'justify-end'}`} data-id="element-288">
                    <motion.div initial={{
                  opacity: 0,
                  x: isEven ? -50 : 50
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.6
                }} className={`w-[45%] ${isEven ? 'text-right pr-12' : 'text-left pl-12'}`} data-id="element-289">
                      <h3 className="font-playfair font-bold text-white text-2xl mb-3" data-id="element-290">
                        {step.title}
                      </h3>
                      <p className="font-montserrat text-white/80 text-base leading-relaxed" data-id="element-291">
                        {step.text}
                      </p>
                    </motion.div>
                  </div>

                  {/* Circle Marker */}
                  <motion.div initial={{
                scale: 0
              }} whileInView={{
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.3,
                type: 'spring'
              }} className="absolute left-6 md:left-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-champagne-gold border-4 border-deep-blue flex items-center justify-center z-10" data-id="element-292">
                    <span className="font-montserrat font-bold text-deep-blue text-sm" data-id="element-293">
                      {step.num}
                    </span>
                  </motion.div>

                  {/* Mobile Layout */}
                  <motion.div initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} className="md:hidden w-full pl-20" data-id="element-294">
                    <h3 className="font-playfair font-bold text-white text-xl mb-2" data-id="element-295">
                      {step.title}
                    </h3>
                    <p className="font-montserrat text-white/80 text-sm leading-relaxed" data-id="element-296">
                      {step.text}
                    </p>
                  </motion.div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}